import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import { WithdrawalGroupEdit } from './types'
import { $params } from '../../../features/router'
import { Error } from '../../clients/edit/types'

export const withdrawalGroupMounted = createEvent()
export const setWithdrawalGroup = createEvent<WithdrawalGroupEdit>()
export const submitEditWithdrawalGroup = createEvent<WithdrawalGroupEdit>()
export const $withdrawalGroup = restore(setWithdrawalGroup, {
  id: 0,
  name: '',
})
export const setError = createEvent<Error>()
export const $error = restore(setError, {
  message: '',
  code: 0,
})
export const getWithdrawalGroup = fx<void, WithdrawalGroupEdit>({
  method: 'GET',
  url: '/withdrawal_group',
})

export const updateWithdrawalGroup = fx<
  WithdrawalGroupEdit,
  WithdrawalGroupEdit
>({
  method: 'PUT',
  url: '/withdrawal_group',
})

sample({
  clock: withdrawalGroupMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.groupID
    }
    return {
      url: `/withdrawal_group/${id}`,
    }
  },
  target: getWithdrawalGroup,
})

sample({
  clock: [getWithdrawalGroup.doneData, updateWithdrawalGroup.doneData],
  fn: (doneData) => doneData.body,
  target: [setWithdrawalGroup],
})

sample({
  clock: submitEditWithdrawalGroup,
  source: $params,
  fn: (params, withdrawalGroup) => {
    let id
    if (params) {
      id = params.groupID
    }
    return {
      url: `/withdrawal_group/${id}`,
      body: { ...withdrawalGroup },
    }
  },
  target: updateWithdrawalGroup,
})
sample({
  clock: [updateWithdrawalGroup.failData],
  fn: (failData) => {
    return { message: failData.body.message, code: failData.body.code }
  },
  target: [setError],
})
$error
  .on(withdrawalGroupMounted, () => {
    return {
      message: '',
      code: 0,
    }
  })
  .on(submitEditWithdrawalGroup, () => {
    return {
      message: '',
      code: 0,
    }
  })
